import { WorkSiteService } from '../services/WorkSiteService';

export function useWorkSiteService(): WorkSiteService {
  return new WorkSiteService(useApiClient(), useUserStore());
}
